import { Component } from '@angular/core';

@Component({
  selector: 'btn-content-google',
  templateUrl: './btn-content-google.component.html',
  styleUrls: ['./btn-content-google.component.scss']
})
export class BtnContentGoogleComponent {
}
